
<section class="modulo-reuniao admin-list">
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-4">
      <h2>Administração</h2>
    </div>
  </div>    
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-4">
      <h2>Níveis de Governança</h2>
    </div>
    <div class="form-group row g-0 col-8 d-flex justify-content-end">
      <div class="button-header col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-primary" type="button" (click)="openModal('governance_level')">Novo Nível</button>
      </div>
    </div>
  </div>   
  <div class="system-table mt-1">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="text-center">Código</th>
            <th class="title">Nome</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody >
          <ng-container *ngFor="let item of data?.governance_level">
            <tr >
              <td class="text-center">{{item?.id}}</td>
              <td >{{item?.name}}</td>
              <td class=" d-flex justify-content-center">
                <button class="btn btn-font-icon" type="button" (click)="openModal('governance_level', item.id)" alt="Editar nível" title="Editar nível">
                  edit_square
                </button>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</section>
<ng-template #modal>
  <app-admin-edit [id]="currentEditId" [type]="currentTypeId" (closeModal)="closeModal()" (excluir)="confirmExcluir(currentEditId, currentTypeId)"></app-admin-edit>
</ng-template>
<app-loading [loader]="isLoading"></app-loading>